<template>
  <div :style="`height:${px(height || '100%')};width:${px(width || '100%')}`"></div>
</template>

<script>
import ace from 'brace'

export default {
  props: {
    value: {
      type: String,
      required: true
    },

    textToInsert: {
      type: String,
      default: ''
    },

    height: {
      type: Number,
      default: 350
    },

    width: {
      type: [Number, String],
      default: '100%'
    },

    options: {
      type: Object,
      default () { return {} }
    },

    name: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      editor: null,
      internalValue: ''
    }
  },

  watch: {
    value (next, old) {
      if (next !== old && next !== this.internalValue) {
        this.internalValue = next
        this.editor.setValue(next, 1)
      }
    },

    textToInsert (next, old) {
      if (next !== old && next !== '') {
        this.insertText(next)
      }
    },

    theme (newTheme) {
      this.editor.setTheme('ace/theme/' + newTheme)
    },

    lang (newLang) {
      this.editor.getSession().setMode('ace/mode/' + newLang)
    },

    options (newOption) {
      this.editor.setOptions(newOption)
    },

    height () {
      this.$nextTick(() => {
        this.editor.resize()
      })
    },

    width () {
      this.$nextTick(() => {
        this.editor.resize()
      })
    }
  },

  methods: {
    px (n) {
      if (/^\d*$/.test(n)) {
        return `${n}px`
      }

      return n
    },

    insertText (s) {
      this.editor.session.insert(this.editor.selection.getCursor(), s)
      this.$emit('inserted')
    }
  },

  created () {
    this.internalValue = this.value
  },

  mounted () {
    const self = this

    const lang = self.lang || 'html'
    const theme = self.theme || 'monokai'

    require('brace/ext/emmet')

    const editor = self.editor = ace.edit(self.$el)
    require('brace/ext/language_tools')
    require('brace/mode/html')
    require('brace/theme/monokai')

    editor.$blockScrolling = Infinity
    editor.setOption('enableEmmet', true)
    editor.getSession().setMode('ace/mode/' + lang)
    editor.setTheme('ace/theme/' + theme)
    editor.setValue(self.value, 1)

    editor.on('change', () => {
      const content = editor.getValue()
      self.$emit('input', content)
      self.internalValue = content
    })

    // editor.session.selection.on('changeCursor', (e, selection) => {
    //   self.$emit('cursor-change', selection.anchor)
    // })

    if (self.options) {
      editor.setOptions(self.options)
    }
  },

  beforeDestroy () {
    this.editor.destroy()
    this.editor.container.remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/AceTextArea.vue